module.exports = __webpack_public_path__ + "static/media/welcome-low-resolution-copy-2000x595.83f324a5.jpg";